import{useRef as r,useLayoutEffect as n}from"react";var t=function(){var t=r(null);return n((function(){t.current&&(t.current(),t.current=null)})),function(r){return t.current=r}};export{t as useRunAfterUpdate};
